import { ChangeEvent, FC, ReactElement, useMemo } from 'react';
import Icon from '../Icon';
import Typography from '../Typography';
import './Checkbox.scss';

export interface CheckboxProps {
  checked: boolean;
  label?: string | ReactElement;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
}

let idCounter = 0;

const Checkbox: FC<CheckboxProps> = props => {
  const { checked, label, onChange } = props;
  const id = useMemo(() => {
    idCounter += 1;
    return `checkbox-${idCounter}`;
  }, []);

  return (
    <div className="nostra__checkbox">
      <span className="nostra__checkbox__box-container" data-checked={checked}>
        <input id={id} checked={checked} type="checkbox" onChange={onChange} />
        {checked ? <Icon variant="checkmark" size={12} color="--neutral-100" /> : null}
      </span>
      {label && (
        <label htmlFor={id} className="tc__checkbox__label">
          <Typography variant="input-body-lg">{label}</Typography>
        </label>
      )}
    </div>
  );
};

export default Checkbox;
